import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Heart } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { fileUrl, mediaSrc } from "../components/site/HeroSlides";

export default function ThanksListenPage() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/voice-thanks/${token}`, { params: { g: sp.get("g") || undefined } }).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e))); }, [token, sp]);
  if (err) return <div className="min-h-screen flex items-center justify-center p-6 text-center text-[var(--muted)]" data-testid="thanks-error">{err}</div>;
  if (!d) return <div className="min-h-screen bg-[#111]" />;
  const cover = mediaSrc(d.cover_image);
  return (
    <div className="min-h-[100dvh] bg-[#111] text-white relative overflow-hidden flex items-center justify-center px-6 py-16" data-testid="thanks-page">
      {cover && <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black" />
      <div className="relative w-full max-w-lg text-center animate-[fadeIn_0.8s_ease-out]">
        <Heart className="w-7 h-7 mx-auto text-[var(--gold)] mb-4" />
        <p className="text-[11px] uppercase tracking-[0.35em] text-[var(--gold)] mb-3">{d.guest_name ? `For ${d.guest_name}` : "With love"}</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl mb-2">Thank you</h1>
        <p className="font-script text-3xl text-[var(--gold)] mb-8" data-testid="thanks-couple">{d.couple_names}</p>
        <audio src={fileUrl(d.audio_path)} controls autoPlay className="w-full mb-8" data-testid="thanks-audio" />
        <p className="font-serif text-lg leading-relaxed text-white/85 whitespace-pre-line" data-testid="thanks-text">{d.text}</p>
        {d.slug && <Link to={`/site/${d.slug}`} className="inline-block mt-10 text-xs uppercase tracking-[0.25em] text-white/60 hover:text-[var(--gold)] transition-colors" data-testid="thanks-site-link">Visit our wedding site</Link>}
      </div>
    </div>
  );
}
